import { defineMessages } from "@formatjs/intl"
import type { CustomerType } from "./CustomerType"

export const customerTypeMessages = defineMessages<CustomerType>({
	END_CUSTOMER: {
		defaultMessage: "End Customer",
		id: "customerType.endCustomer",
	},
	RESELLER: {
		defaultMessage: "Reseller",
		id: "customerType.reseller",
	},
})
